import { HealthConditionDetailContainer } from './HealthConditionsDetailsContainer';
import { useGetHealthConnectionL4Detail } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { useParams } from 'react-router-dom';

export const HealthConditionDetailPage = () => {
  const { condition: conditionName, id: scoreId } = useParams();
  const { data: conditionDetailData, isLoading } = useGetHealthConnectionL4Detail(conditionName || '', Number(scoreId));

  return (
    <div className="dark bg-black h-full w-full">
      <HealthConditionDetailContainer
        condition={conditionDetailData && conditionDetailData}
        isLoading={isLoading}
        scoreId={Number(scoreId)}
      />
    </div>
  );
};
